import { gql } from '@apollo/client';
import { SPECIMEN_FRAGMENT } from '../CreateEditSpecimenForm/queries';

export const SPECIMEN_BY_SLUG = gql`
${SPECIMEN_FRAGMENT}
query specimenBySlug($slug: String!) {
  specimanBySlug(slug: $slug) {
    ...specimanFragment
    specimenCoMappersBySpecimenId {
      nodes {
        user {
          id
          name
          totalCredits
          isTerritoryMentor
          username
          avatarUrl
        }
      }
    }
    territoriesByCoordinatesCurrentUserMentor: territoriesByCoordinatesGeometry(filter: {isCurrentUserMentor: {equalTo: true}}) {
      totalCount
    }
    speciesSpecimenReviewCommentsBySpecimenId(orderBy: CREATED_AT_DESC) {
      nodes {
        id
        createdAt
        content
        createdByUser {
          avatarUrl
          name
          username
          isTerritoryMentor
        }
      }
    }
    speciesSpecimenCommentsBySpecimenId(orderBy: CREATED_AT_DESC) {
      nodes {
        id
        createdAt
        content
        createdByUser {
          avatarUrl
          name
          username
          isTerritoryMentor
        }
      }
    }
  }
}
`;

export const SPECIMEN_BY_SLUG_NAV = gql`
${SPECIMEN_FRAGMENT}
query specimenBySlugNav($slug: String!) {
  specimanBySlug(slug: $slug) {
    ...specimanFragment
  }
  unCompletedRouteStops: routeStops(
    filter: {routeStopUserStatuses: {none: {hasCompleted: {equalTo: true}}}, specimen: {slug: {equalTo: $slug}}}
    first: 1
  ) {
    nodes {
      id
      slug
    }
  }
  allRouteStops:routeStops(
    filter: {specimen: {slug: {equalTo: $slug}}}
  ) {
    nodes {
      id
      slug
    }
    totalCount
  }
}
`;

export const CREATE_USER_SPECIMAN = gql`
mutation createUserSelfObservedSpeciman(
  $specimenId: UUID!
  $userId: UUID!
) {
  createUserSpeciman(
    input: {
      userSpeciman: {
        userId: $userId
        specimenId: $specimenId
        isSelfObserved: true
      }
    }
  ) {
    userSpeciman {
      id
      isSelfObserved
      userId
      specimenId
    }
  }
}
`;
